<template>
  <div class="table-container">
    <el-table :data="data"
              :ref="refs"
              stripe
              fit
              header-cell-class-name="custom-header" @select="handleSelectItem" @select-all="handleSelectAll" @expand-change="expandChange">
      <slot></slot>
    </el-table>
    <slot name="pagination">
      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="getList" :current-page.sync="params.page"
                       :page-sizes="[5,10,20,30, 50]" :page-size="params.rows" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: function () {
        return []
      }
    },
    refs: {
      type: String,
      default: 'basicTable'
    },
    params: {
      type: Object,
      default: function () {
        return {}
      }
    },
    total: {},
    getList: {
      type: Function
    },
    expandChange: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    handleSelectItem (selection, row) {
      this.$emit('select', selection, row)
    },
    handleSelectAll (selection) {
      this.$emit('select-all', selection)
    },
    handleSizeChange (val) {
      this.params.rows = val
      this.getList()
    }
  }
}
</script>
<style lang="scss">
 .table-container{
  border-top: 1px solid #DCDFE6;
  background: #fff;
  .custom-header{
    background: #F5F7FA !important;
    color: #333;
    border-bottom: 1px solid #DCDFE6 !important;
  }
  .el-table--enable-row-hover .el-table__body tr:hover>td {
    background-color: #EAF3FD;
  }
  .pagination-container{
    margin-top: 10px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BasicTable/BasicTable.vue